import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCityes } from "../../redux/state/citiesReduser/citiesFetchService";
import {
  selectCities,
  selectCityIsLoading,
  selectCityError,
} from "../../redux/state/citiesReduser/cities.redusers";
import { Link } from "react-router-dom";
import { Box, Grid, Slide, Typography } from "@mui/material";
import CityCard from "./CityCard";
import Alphabet from "../Alphabet/Alphabet";
import Pagination from "../Pagination/Pagination";
import { gridContainerStyles, gridItemStyles } from "./CitiesList.styles";
import Loader from "../Loader/Loader";
import { operator } from "../../srevices/contacts";

function CitiesList() {
  const dispatch = useDispatch();
  const citiesList = useSelector(selectCities);
  const isLoading = useSelector(selectCityIsLoading);
  const error = useSelector(selectCityError);
  const [filteredCities, setFilteredCities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const citiesPerPage = 10;
  const mounted = true;

  useEffect(() => {
    dispatch(fetchCityes());
  }, [dispatch]);

  useEffect(() => {
    if (citiesList) {
      setFilteredCities(citiesList);
    }
  }, [citiesList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const indexOfLastCity = currentPage * citiesPerPage;
  const indexOfFirstCity = indexOfLastCity - citiesPerPage;
  const currentCities = filteredCities.slice(indexOfFirstCity, indexOfLastCity);
  const totalPages = Math.ceil(filteredCities.length / citiesPerPage);

  return (
    <Slide direction="left" in={mounted} timeout={1000}>
      <Box sx={{ padding: 2 }}>
        {/* Баннер: всегда показывается */}
        <Box 
          sx={{
            position: "relative",
            backgroundColor: "#ffcc00",
            padding: "15px 0",
            textAlign: "center",
            zIndex: 1000,
            marginBottom: "30px",
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
            animation: "neon-flicker 1.5s ease-in-out infinite alternate",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "black",
              textShadow: "0 0 5px #fff, 0 0 10px #fff, 0 0 15px #ff00cc, 0 0 20px #ff00cc, 0 0 25px #ff00cc",
              fontSize: "18px",
              lineHeight: "1.4",
            }}
          >
            🌆ПГТ и Города с населением менее 200к человек доступны только у{" "}
            <a
              href={operator}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#000", textDecoration: "underline", display: "inline-block" }}
            >
              оператора
            </a>{" "}
            или на Кракене.
          </Typography>
        </Box>

        {/* Ошибка */}
        {error && (
         <Box
         sx={{
           backgroundColor: "#fff3cd",
           border: "1px solid #ffeeba",
           borderRadius: "12px",
           padding: 3,
           marginBottom: 4,
           textAlign: "center",
           boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
           animation: "pulse 2s infinite",
           maxWidth: 600,
           mx: "auto",
         }}
       >
         <Typography
           variant="h5"
           sx={{
             fontWeight: "bold",
             color: "#856404",
             display: "flex",
             alignItems: "center",
             justifyContent: "center",
             gap: 1,
             mb: 1,
           }}
         >
           ⚠️ Ведутся технические работы 
         </Typography>
       
         <Typography
           variant="body1"
           sx={{ fontSize: "18px", color: "#856404" }}
         >
           Все заказы временно доступны у оператора{" "}
           <a
             href={operator}
             target="_blank"
             rel="noopener noreferrer"
             style={{
               textDecoration: "underline",
               fontWeight: 600,
               color: "#533f03",
             }}
           >
             Дом
           </a>
         </Typography>
       </Box>
       
        )}

        {/* Загрузка */}
        {isLoading && <Loader />}

        {/* Основной контент (если нет ошибки и не грузится) */}
        {!isLoading && !error && (
          <>
            <Alphabet
              citiesList={citiesList}
              setCurrentPage={setCurrentPage}
              setFilteredCities={setFilteredCities}
            />

            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  textAlign: "center",
                  color: "primary.main",
                }}
              >
                Выберите город
              </Typography>
            </Box>

            <Grid container sx={gridContainerStyles} spacing={3}>
              {currentCities.map((city) => (
                <Grid item key={city._id} sx={gridItemStyles}>
                  <Link to={`/cities/${city?._id}`} style={{ textDecoration: "none" }}>
                    <CityCard city={city} />
                  </Link>
                </Grid>
              ))}
            </Grid>

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </>
        )}
      </Box>
    </Slide>
  );
}

export default CitiesList;
